<template>
	<view class="box">
		<view class="cate">
			<view v-for="(item, index) in cate" :key="index" @click="i = index" :class="i === index ? 'cate-item active' : 'cate-item'">
				<text>{{item}}</text>
				<view class="cate-item-x" v-if="i === index"></view>
			</view>
			<view class="cate-item" style="flex: 0.7; justify-content: flex-end; padding-right: 30rpx; box-sizing: border-box;">
				<image src="/static/icon/ic_guanli@2x.png" mode="widthFix"></image>
				<text class="wz">管理</text>
			</view>
		</view>
		<!-- <view class="list1">
			<view class="list-item">
				<view class="left">
					<image src="/static/icon/ic_agree@2x.png" mode="widthFix"></image>
				</view>
				<view class="right">
					<view class="list-item-image">
						<image src="/static/logo.png" mode="widthFix"></image>
					</view>
					<view class="list-item-info">
						<view class="list-item-info-top">曲轴减震器皮带轮A12</view>
						<view class="list-item-info-bottom">
							<text>¥398.00</text>
							<text>¥498.00</text>
						</view>
					</view>
				</view>
			</view>
		</view> -->
		<view class="list">
			<view class="list-item" v-for="(item, index) in 5" :key="index">
				<view class="info">
					<view class="check">
						<image src="/static/icon/ic_agree@2x.png" mode="widthFix"></image>
					</view>
					<view class="info-right">
						<view class="info-title">挖掘机在冬季起动为什么困难？</view>
						<view class="info-desc">挖掘机在冬季起动为什么困难？不仅决定于本身的技术状况，还受外界气温的影响</view>
						<view class="info-data">
							<view class="tips">维修</view>
							<text>100 阅读｜2025-10-10 21:00</text>
						</view>
					</view>
				</view>
				<view class="image">
					<image src="/static/logo.png" mode="widthFix"></image>
				</view>
			</view>
		</view>
		<view style="width: 100%; height: calc(100rpx + env(safe-area-inset-bottom));"></view>
		<view class="footer">
			<view class="caozuo">
				<view class="caozuo-left">
					<image src="/static/icon/ic_agree@2x.png" mode="widthFix"></image>
					<text>全选</text>
				</view>
				<view class="caozuo-btn">删除(0)</view>
			</view>
			<view style="width: 100%; height: env(safe-area-inset-bottom);"></view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				i: 0,
				cate: ['商品(12)', '文章(5)']
			};
		}
	}
</script>

<style>
	page {
		background-color: #F9F9FB;
	}
</style>
<style lang="scss" scoped>
	.box {
		width: 100%;
		.footer {
			width: 100%;
			background-color: #ffffff;
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 999;
			height: calc(100rpx + env(safe-area-inset-bottom));
			.caozuo {
				width: 100%;
				height: 100rpx;
				padding: 0 30rpx;
				box-sizing: border-box;
				display: flex;
				align-items: center;
				justify-content: space-between;
				box-shadow: 0rpx -1rpx 0rpx 0rpx #EEEEEE;
				.caozuo-left {
					display: flex;
					align-items: center;
					image {
						width: 40rpx;
						height: 40rpx;
						margin-right: 16rpx;
					}
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #333333;
					}
				}
				.caozuo-btn {
					padding: 0 36rpx;
					box-sizing: border-box;
					height: 64rpx;
					line-height: 64rpx;
					border-radius: 32rpx;
					border: 1rpx solid #E4001D;
					font-weight: 400;
					font-size: 28rpx;
					color: #E4001D;
				}
			}
		}
		.cate {
			width: 100%;
			height: 90rpx;
			background: #FFFFFF;
			display: flex;
			align-items: center;
			position: sticky;
			top: 0;
			left: 0;
			z-index: 99;
			border-bottom: 1rpx solid #E5E5E5;
			.active {
				text {
					font-weight: 500 !important;
					font-size: 32rpx !important;
					color: #222222 !important;
				}
			}
			.cate-item {
				flex: 1;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				image {
					width: 28rpx;
					height: 28rpx;
					margin-right: 8rpx;
				}
				.wz {
					font-weight: 400;
					font-size: 26rpx;
					color: #666666;
				}
				text {
					font-weight: 400;
					font-size: 30rpx;
					color: #666666;
				}
				.cate-item-x {
					width: 40rpx;
					height: 6rpx;
					position: absolute;
					bottom: 0;
					left: 50%;
					transform: translate(-50%, 0);
					background-color: #004096;
				}
			}
		}
		.list {
			width: 100%;
			padding: 0 30rpx;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			background-color: #ffffff;
			.list-item {
				width: 100%;
				padding: 30rpx 0;
				box-sizing: border-box;
				display: flex;
				align-items: flex-start;
				border-bottom: 1rpx solid #E5E5E5;
				
				.info {
					flex: 1;
					display: flex;
					align-items: center;
					.check {
						flex-shrink: 0;
						width: 44rpx;
						height: 44rpx;
						margin-right: 20rpx;
						image {
							width: 100%;
						}
					}
					.info-right {
						display: flex;
						flex-direction: column;
						.info-title {
							font-weight: 600;
							font-size: 32rpx;
							color: #222222;
						}
						.info-desc {
							font-weight: 400;
							font-size: 26rpx;
							color: #777777;
							margin-top: 16rpx;
						}
						.info-data {
							display: flex;
							align-items: flex-start;
							margin-top: 20rpx;
							.tips {
								flex-shrink: 0;
								height: 40rpx;
								line-height: 40rpx;
								padding: 0 8rpx;
								box-sizing: border-box;
								background: rgba(0,183,117,0.1);
								border-radius: 8rpx;
								
								font-weight: 400;
								font-size: 22rpx;
								color: #00B775;
								margin-right: 20rpx;
							}
							text {
								font-weight: 400;
								font-size: 24rpx;
								color: #999999;
							}
						}
					}
				}
				.image {
					flex-shrink: 0;
					width: 200rpx;
					height: 150rpx;
					border-radius: 8rpx;
					margin-left: 30rpx;
					overflow: hidden;
					image {
						width: 100%;
					}
				}
			}
		}
		.list1 {
			width: 100%;
			padding: 30rpx;
			box-sizing: border-box;
			.list-item {
				width: 100%;
				display: flex;
				align-items: center;
				margin-bottom: 20rpx;
				&:last-child {
					margin: 0 !important;
				}
				.left {
					flex-shrink: 0;
					width: 40rpx;
					height: 40rpx;
					margin-right: 20rpx;
					image {
						width: 100%;
					}
				}
				.right {
					flex: 1;
					padding: 30rpx;
					box-sizing: border-box;
					background: #FFFFFF;
					border-radius: 16rpx;
					display: flex;
					align-items: center;
					.list-item-image {
						flex-shrink: 0;
						width: 144rpx;
						height: 144rpx;
						overflow: hidden;
						border-radius: 8rpx;
						border: 1rpx solid #EEEEEE;
						margin-right: 24rpx;
						image {
							width: 100%;
						}
					}
					.list-item-info {
						flex: 1;
						height: 144rpx;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						.list-item-info-top {
							font-weight: 400;
							font-size: 30rpx;
							color: #222222;
						}
						.list-item-info-bottom {
							display: flex;
							align-items: baseline;
							text {
								&:nth-child(1) {
									font-weight: 600;
									font-size: 30rpx;
									color: #E4001D;
								}
								&:nth-child(2) {
									font-weight: 400;
									font-size: 24rpx;
									color: #999999;
									margin-left: 10rpx;
								}
							}
						}
					}
				}
			}
		}
	}
</style>